/* =============================================================================
   IRREAL — Upsell inteligente do Cart Drawer (v2 — N sabores)
   -----------------------------------------------------------------------------
   REGRAS:
   1) Carrinho só com produtos simples  -> sugere os sabores que NÃO estão no
      carrinho (exclui todos os que já estão, mesmo com 2+ itens).
   2) Carrinho com QUALQUER combo       -> sugere TODOS os sabores da coleção
      "upsell", mesmo os que aparecem como linhas do combo.
      (Combo é detectado pelas propriedades ocultas _total_children /
       _parent_variant_id / _bundle_multiplier, ou pelo kit degustação
       _kit_group / "Kit".)
   3) Sem sabor pra sugerir             -> esconde o bloco inteiro.
 
   A quantidade de cada card é escolhida pelas faixas do produto (quantidade_1/2/3):
   prioriza a faixa que COMPLETA a meta de recompensa (ex.: 20 un = 15% OFF +
   Frete Grátis, lido da barra de progressão APX).
============================================================================= */
(function initIrrealUpsell() {
  if (window.__IRREAL_UPSELL__) return;
  window.__IRREAL_UPSELL__ = true;
 
  var BUNDLE_FALLBACK = [6, 10, 20];
  var MAX_CARDS = 5;
 
  // ---- estado interno (evita corridas) -------------------------------------
  var rendering = false;
  var scrolling = false;
  var scrollTimer = null;
  var syncing = false;
  var syncQueued = false;
  var applyTimer = null;
 
  // ---- helpers --------------------------------------------------------------
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
 
  function toInt(v) {
    var n = parseInt(String(v == null ? '' : v).trim(), 10);
    return isFinite(n) ? n : null;
  }
 
  function moneyBR(cents) {
    var v = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);
    } catch (e) {
      return 'R$ ' + v.toFixed(2).replace('.', ',');
    }
  }
 
  function cardTiers(card) {
    var t = [card.dataset.bqQ1, card.dataset.bqQ2, card.dataset.bqQ3]
      .map(toInt).filter(function (n) { return n && n > 0; });
    if (!t.length) return BUNDLE_FALLBACK.slice();
    return t.sort(function (a, b) { return a - b; });
  }
 
  // preço por unidade considerando as faixas de volume (quantity_price_breaks)
  function unitPriceForQty(card, qty) {
    var base = toInt(card.dataset.basePrice) || 0;
    var tiers = [];
    try { tiers = JSON.parse(card.dataset.tierPrices || '[]') || []; } catch (e) { tiers = []; }
    var price = base;
    tiers
      .sort(function (a, b) { return a.min - b.min; })
      .forEach(function (b) { if (qty >= b.min) price = b.price; });
    return price; // em centavos
  }
 
  // ---- meta de recompensa (lida da barra de progressão APX) -----------------
  function readRewardGoal() {
    var cfg = $('[data-apx-cart-progress-config]');
    var goal = { metric: 'quantity', threshold: 20, title: '15% OFF + Frete Grátis' };
    if (!cfg) return goal;
 
    var settings = {}, tiers = [];
    try { settings = JSON.parse($('[data-apx-cart-progress-settings]', cfg).textContent || '{}'); } catch (e) {}
    try { tiers = JSON.parse($('[data-apx-cart-progress-tiers]', cfg).textContent || '[]') || []; } catch (e) {}
 
    var metric = settings.mode === 'money' ? 'money'
      : settings.mode === 'quantity' ? 'quantity'
      : (tiers[0] && tiers[0].metric) || 'quantity';
 
    var chain = tiers.filter(function (t) { return t && t.metric === metric; });
    if (!chain.length) return goal;
 
    chain.sort(function (a, b) {
      var ta = metric === 'money' ? Number(a.threshold) * 100 : Number(a.threshold);
      var tb = metric === 'money' ? Number(b.threshold) * 100 : Number(b.threshold);
      return ta - tb;
    });
    var top = chain[chain.length - 1];
    goal.metric = metric;
    goal.threshold = metric === 'money' ? Math.round(Number(top.threshold) * 100) : Number(top.threshold);
    goal.title = (top.benefit_title || goal.title).trim();
    return goal;
  }
 
  // ---- leitura do carrinho --------------------------------------------------
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }
 
  // Uma linha faz parte de um combo? (marcas deixadas pelo snippet bundle_qty
  // e pelo kit degustação)
  function isComboLine(item) {
    var p = (item && item.properties) || {};
    return !!(p._total_children || p._parent_variant_id || p._bundle_multiplier || p._kit_group || p.Kit);
  }
 
  function analyze(cart) {
    var a = { total: 0, hasCombo: false, inCart: {} };
    if (!cart || !cart.items) return a;
 
    cart.items.forEach(function (it) {
      var qty = Number(it.quantity || 0);
      a.total += qty;
 
      if (isComboLine(it)) {
        a.hasCombo = true;
        return; // linha de combo NÃO bloqueia o sabor no upsell
      }
      var h = it.handle || (it.product && it.product.handle);
      if (h) a.inCart[h] = (a.inCart[h] || 0) + qty;
    });
 
    return a;
  }
 
  // ---- escolha de quantidade ------------------------------------------------
  function tierThatCompletes(tiers, total, threshold) {
    for (var i = 0; i < tiers.length; i++) if (total + tiers[i] === threshold) return tiers[i];
    return null;
  }
  function tierThatReaches(tiers, total, threshold) {
    for (var i = 0; i < tiers.length; i++) if (total + tiers[i] >= threshold) return tiers[i];
    return null;
  }
 
  // ---- plano de sugestões ---------------------------------------------------
  // Retorna lista ordenada de { card, qty, headline, reward }
  function buildPlan(cards, a, goal) {
    var qtyMetric = goal.metric === 'quantity';
    var F = goal.threshold;
    var total = a.total;
    var remaining = qtyMetric ? Math.max(0, F - total) : 0;
 
    var plan = [];
 
    cards.forEach(function (card) {
      if (card.dataset.unavailable === 'true') return;
 
      var handle = card.dataset.handle;
      if (!handle) return;
 
      // REGRA 1: sem combo no carrinho -> pula o que já está lá.
      // REGRA 2: com combo -> não pula nada (mostra os 5).
      if (!a.hasCombo && a.inCart[handle]) return;
 
      var tiers = cardTiers(card);
     var qty = tiers[0];
      var reward = false;
      var headline;

      if (qtyMetric && remaining > 0 && !a.hasCombo) {
        var pick = tierThatCompletes(tiers, total, F) || tierThatReaches(tiers, total, F);
        if (pick) {
          qty = pick;
          reward = (total + pick) >= F;
        }
        if (reward) {
          headline = 'Falta pouco! Complete ' + F + ' e ganhe ' + goal.title;
        } else {
          headline = 'Faltam ' + remaining + ' un para ' + goal.title;
        }
      } else {
        // meta já batida (ou métrica em R$) -> foco em variedade
        headline = 'Aproveite e leve outro sabor também';
      }
 
      plan.push({ card: card, qty: qty, headline: headline, reward: reward });
    });
 
    // recompensa primeiro; depois menor quantidade primeiro
    plan.sort(function (x, y) {
      if (x.reward !== y.reward) return x.reward ? -1 : 1;
      return x.qty - y.qty;
    });
 
    return plan.slice(0, MAX_CARDS);
  }
 
  // ---- renderização do upsell ----------------------------------------------
  var renderPass = 0;
  function renderPlan(root, plan) {
    rendering = true;
    var pass = ++renderPass;
    var track = $('.upsell__track', root);
    if (!track) { rendering = false; return; }
 
    var allCards = $all('.upsell-card', track);
    allCards.forEach(function (c) { c.hidden = true; });
 
    if (!plan.length) {
      root.hidden = true;
      rendering = false;
      return;
    }
 
    plan.forEach(function (sug) {
      var node = sug.card;
      node.hidden = false;
      decorateCard(node, sug);
      node.dataset.pass = String(pass);
      track.appendChild(node); // reordena na DOM conforme o plano
    });
 
    // 🔒 segurança: nunca mostrar um card que não foi decorado nesta passada
    $all('.upsell-card', track).forEach(function (c) {
      if (c.dataset.pass !== String(pass)) c.hidden = true;
    });
 
    root.hidden = false;
    updateArrows(root);
    rendering = false;
  }
 
  function decorateCard(node, sug) {
    var hook = $('[data-upsell-hook]', node);
    if (hook) {
      hook.hidden = false;
      hook.classList.toggle('is-reward', !!sug.reward);
      hook.innerHTML = '<span class="ir-dot" aria-hidden="true"></span>' + escapeHtml(sug.headline);
    }
    node.classList.toggle('is-reward', !!sug.reward);
 
    var unit = unitPriceForQty(node, sug.qty);
    var priceWrap = $('[data-upsell-price]', node);
    if (priceWrap) {
      var base = toInt(node.dataset.basePrice) || unit;
      var oldHtml = base > unit ? '<s class="upsell-card__price--old">' + moneyBR(base) + '</s> ' : '';
      priceWrap.innerHTML =
        oldHtml +
        '<span class="upsell-card__price--now">' + moneyBR(unit) + '</span>' +
        '<span class="upsell-card__price--unit">/un</span>' +
        '<span class="upsell-card__price--total">' + sug.qty + ' un = ' + moneyBR(unit * sug.qty) + '</span>';
    }
 
    var media = $('.upsell-card__media', node);
    if (media) {
      var badge = $('.upsell-card__qty-badge', media);
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'upsell-card__qty-badge';
        media.appendChild(badge);
      }
      badge.textContent = sug.qty + ' un';
    }
 
    var btn = $('.upsell-card__add', node);
    if (btn) {
      btn.dataset.addQty = String(sug.qty);
      var label = $('[data-upsell-add-label]', btn);
      var txt = 'Adicionar ' + sug.qty + ' un';
      if (label) label.textContent = txt; else btn.textContent = txt;
    }
  }
 
  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
 
  function applySmartUpsell() {
    var root = $('#CartDrawer-Upsell');
    if (!root) return Promise.resolve();
    return getCart().then(function (cart) {
      if (!cart) return;
      var goal = readRewardGoal();
      var a = analyze(cart);
 
      // TODOS os cards da coleção "upsell", um por produto (handle único)
      var cards = $all('.upsell-card', root);
 
      var plan = buildPlan(cards, a, goal);
      renderPlan(root, plan);
    });
  }
 
  function scheduleApply() {
    clearTimeout(applyTimer);
    applyTimer = setTimeout(applySmartUpsell, 150);
  }
 
  // ---- carrossel (delegação — nunca listener morto) -------------------------
  function updateArrows(root) {
    var track = $('.upsell__track', root);
    var prev = $('.upsell__btn--prev', root);
    var next = $('.upsell__btn--next', root);
    if (!track) return;
    var maxScroll = track.scrollWidth - track.clientWidth - 2;
    var multi = maxScroll > 4;
    if (prev) prev.disabled = !multi || track.scrollLeft <= 2;
    if (next) next.disabled = !multi || track.scrollLeft >= maxScroll;
    var nav = $('.upsell__nav', root);
    if (nav) nav.style.visibility = multi ? '' : 'hidden';
  }
 
  function scrollTrack(root, dir) {
    var track = $('.upsell__track', root);
    if (!track) return;

    var cards = $all('.upsell-card:not([hidden])', track);
    if (!cards.length) return;

    var origin = cards[0].offsetLeft;
    var cur = track.scrollLeft;
    var target = null;

    if (dir > 0) {
      for (var i = 0; i < cards.length; i++) {
        if ((cards[i].offsetLeft - origin) > cur + 2) { target = cards[i]; break; }
      }
      if (!target) target = cards[cards.length - 1];
    } else {
      for (var j = cards.length - 1; j >= 0; j--) {
        if ((cards[j].offsetLeft - origin) < cur - 2) { target = cards[j]; break; }
      }
      if (!target) target = cards[0];
    }

    scrolling = true;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () { scrolling = false; }, 600);

    track.scrollTo({ left: target.offsetLeft - origin, behavior: 'smooth' });
  }
 
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.upsell__btn');
    if (!btn) return;
    var root = btn.closest('#CartDrawer-Upsell');
    if (!root) return;
    ev.preventDefault();
    scrollTrack(root, btn.classList.contains('upsell__btn--prev') ? -1 : 1);
  });
 
  document.addEventListener('scroll', function (ev) {
    var track = ev.target;
    if (!track || !track.classList || !track.classList.contains('upsell__track')) return;
    var root = track.closest('#CartDrawer-Upsell');
    if (root) updateArrows(root);
  }, true);
 
  // ---- adicionar + refresh coordenado --------------------------------------
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.upsell-card__add');
    if (!btn) return;
    var root = btn.closest('#CartDrawer-Upsell');
    if (!root) return;
 
    ev.preventDefault();
    ev.stopPropagation();
    if (btn.__busy) return;
    btn.__busy = true;
 
    var variantId = toInt(btn.dataset.variantId);
    var qty = toInt(btn.dataset.addQty) || 6;
    if (!variantId) { btn.__busy = false; return; }
 
    btn.classList.add('is-loading');
    btn.disabled = true;
 
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty, properties: { _bundle_qty: qty } })
    })
      .then(function (r) { if (!r.ok) throw new Error('add falhou ' + r.status); return r.json(); })
      .then(function () { return syncDrawer(); })
      .catch(function (e) { console.warn('[IRREAL upsell] add', e); })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        setTimeout(function () { btn.__busy = false; }, 50);
      });
  }, true);
 
  function syncDrawer() {
    if (syncing) { syncQueued = true; return Promise.resolve(); }
    syncing = true;
 
    return fetch('/cart?section_id=cart-drawer', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        swap(doc, '#CartDrawer-CartItems');
        swap(doc, '.drawer__footer');
        swap(doc, '#CartDrawer-Upsell');
      })
      .then(function () { return applySmartUpsell(); })
      .then(function () {
        try { window.dispatchEvent(new CustomEvent('apx:cart-mutated')); } catch (e) {}
      })
      .catch(function (e) { console.warn('[IRREAL upsell] sync', e); })
      .finally(function () {
        syncing = false;
        if (syncQueued) { syncQueued = false; syncDrawer(); }
      });
  }
 
  function swap(doc, sel) {
    var neu = doc.querySelector(sel);
    var cur = document.querySelector(sel);
    if (neu && cur) cur.replaceWith(neu);
  }
 
  // ---- gatilhos ------------------------------------------------------------
  window.addEventListener('apx:cart-mutated', scheduleApply);
 
  var moTimer = null;
  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__irrealObserved) return;
    drawer.__irrealObserved = true;
 
    var mo = new MutationObserver(function (muts) {
      if (rendering || syncing || scrolling) return;
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && t.closest('#CartDrawer-Upsell')) return;
      }
      clearTimeout(moTimer);
      moTimer = setTimeout(applySmartUpsell, 160);
    });
    mo.observe(drawer, { childList: true, subtree: true });
 
    drawer.addEventListener('transitionend', function () {
      scheduleApply();
      var root = $('#CartDrawer-Upsell');
      if (root) updateArrows(root);
    });
  }
 
  function boot() {
    observeDrawer();
    applySmartUpsell();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
 
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && String(e.detail.sectionId || '').indexOf('cart-drawer') >= 0) {
      observeDrawer();
      scheduleApply();
    }
  });
 
  window.addEventListener('resize', function () {
    var root = $('#CartDrawer-Upsell');
    if (root) updateArrows(root);
  });
})();
 